import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { DataFieldFor, DynamicColumn } from "../client-contact-fields/models";
import { CustomDataService } from "../client-contact-fields/custom-data.service";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { CsvboxButton } from "./csvbox-imorter/csvbox-importer.component";
import { environment } from "src/environments/environment";
import { SharedDataService } from "src/app/dashboard/shared-data.service";
import { EmptyStateComponent } from "src/app/design-system/components/empty-state/empty-state.component";
@Component({
    selector: "app-import-contacts",
    imports: [CsvboxButton, EmptyStateComponent, RouterModule],
    templateUrl: "./import-data.component.html",
    styleUrls: ["./import-data.component.scss"]
})
export class ImportDataComponent implements OnInit {
  licenseKey;
  user;

  dynamicColumns: DynamicColumn[];
  componentFor: DataFieldFor;
  DataFieldFor = DataFieldFor;
  currentlyProcessing: boolean = false;

  constructor(
    private customDataService: CustomDataService,
    private route: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.licenseKey = environment.csvBoxConfig.licenseKey;
    this.user = this.sharedDataService.user;
    this.route.data.subscribe(({ componentFor }) => {
      this.componentFor = componentFor;
    });
    this.getDyanmicColumns();
  }

  imported(result: boolean, data: any): void {
    console.log(result);
    console.log(data);
  }

  handleCsvboxSubmit(): void {
    this.currentlyProcessing = true;
  }

  async getDyanmicColumns(): Promise<void> {
    const { dynamic_columns } =
      await this.customDataService.getAllDynamicColumns(this.componentFor);
    this.dynamicColumns = dynamic_columns;
  }
}
